const componentIds = {
  ModalHeader: 'ModalHeader',
  ModalBody: 'ModalBody',
  ModalFooter: 'ModalFooter',
};

export { componentIds };
